/*eslint react-hooks/exhaustive-deps: "off"*/
/* eslint-disable no-eval */

import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import InputCheck from 'src/components/InputsDinamicos/InputCheck';
import ShowOnWrapper from 'src/components/InputsDinamicos/ShowOnWrapper';
import {
  validarRuc,
  validDecimales,
  validEmailRegex,
  validEnterosRegex,
  validNombres,
  validPlacaRegex,
  validDirecciones,
} from 'src/utils/validaciones';
import * as uuid from 'uuid';
import InputDate from './InputDate';
import InputFile from './InputFile';
import InputText from './InputText';
import Select from './SelectCopy';
import SelectMultiple from './SelectMultipleCopy';
import './styles.scss';
import SubForm from './SubForm';

const setPatern = (value, message) => ({
  value,
  message,
});

const InputsDinamicos = ({ inputs }) => {
  const [form, setComponent] = useState(null);
  const [inputsDinamicos, setInputsDinamicos] = useState([]);
  useEffect(() => {
    setInputsDinamicos(inputs);
  }, [inputs]);

  useEffect(() => {
    setComponent(
      inputsDinamicos
        .map((e) => ({ ...e, rules: {} }))
        .map((e) => {
          if (e.mandatorio === 'true' || e.mandatorio === true) {
            e.rules.required = 'Este campo es obligatorio';
          }
          if (e?.min) e.rules.min = {
            value: +e.min,
            message: `El ingreso mínimo es de ${+e.min}`,
          }
          if (e?.max) e.rules.max = {
            value: +e.max + 1,
            message: `El ingreso máximo es de ${+e.max + 1}`,
          };

          let retorno = {
            ...e,
            longitud: e.longitud,
            name: e.codCore,
            label: e.campo,
            required: e.mandatorio === 'true',
            unique: e.unico || 'false',
            type: e.validacion,
            disabled: e.disabled ?? false
          };


          if ((e.validacion === 'texto' || e.validacion === 'number' || e.validacion === 'numeros') && !retorno.disabled) {
            retorno.disabled = (!!`${e.editable}` && `${e.editable}` === 'false');
          }
          return retorno
        })
        .map((input) => {



          switch (input.type) {
            case 'cedula':
              input.subType = input.subType || 'number';
              if (!input?.customValidation) {
                input.rules = {
                  validate: (value) => {
                    if (value?.length !== 10) {
                      return 'Ingrese una identificación válida';
                    }
                    const validation = validarRuc(value);
                    if (validation) {
                      if (input.onValid) {
                        input.onValid(value);
                      }
                      return true;
                    }
                    return 'Ingrese una identificación correcta';
                  },
                };
              }

              return {
                component: <InputText input={input} />,
                input,
              };
            case 'celular':
              input.subType = 'number';

              input.rules = {
                ...input.rules,
                maxLength: {
                  value: input.length,
                  message: `Solo puede contener ${input.length}`,
                },
                pattern: setPatern(validEnterosRegex, 'Ingrese un número de celular válido'),
              };
              return { component: <InputText input={input} />, input };
            case 'email':
              input.subTyoe = 'email';
              input.rules = {
                ...input.rules,
                pattern: setPatern(validEmailRegex, 'Ingrese un correo válido'),
              };

              return { component: <InputText input={input} />, input };
            case 'placa':
              input.subTyoe = 'text';
              input.rules = {
                ...input.rules,
                pattern: setPatern(validPlacaRegex, 'Ingrese una placa válida ejemplo (ABC1234)'),
              };

              if (input.value === '' || !input.value) {
                input.disabled = false;
              }

              input.onSave = ['toUpperCase', 'trim'];
              return { component: <InputText input={input} />, input };
            case 'nombres':
              input.subType = 'text';
              input.rules = {
                ...input.rules,
                pattern: setPatern(
                  validNombres,
                  'El texto ingresado no debe contener caracteres especiales',
                ),
              };
              input.onSave = ['toUpperCase', 'trim'];
              return { component: <InputText input={input} />, input };
            case 'entero':
              input.subType = 'number';
              input.rules = {
                ...input.rules,
                pattern: setPatern(validEnterosRegex, 'Ingrese solo números enteros'),
              };

              if (input.min) {
                input.rules.min = {
                  value: input.min,
                  message: `El ingreso mínimo es de ${input.min}`,
                };
              }
              if (input.max) {
                input.rules.max = {
                  value: input.max,
                  message: `El ingreso máximo es de ${input.max}`,
                };
              }

              return { component: <InputText input={input} />, input };
            case 'decimal':
              input.subType = 'number';
              input.rules = {
                ...input.rules,
                pattern: setPatern(validDecimales, 'Ingrese solo números decimales'),
              };

              return { component: <InputText input={input} />, input };
            case 'texto':
              input.subType = 'text';
              input.rules = {
                ...input.rules,
                pattern: setPatern(validNombres, 'El texto ingresado no debe contener caracteres'),
              };
              return { component: <InputText input={input} />, input };
            case 'telefono':
              input.subType = 'number';
              input.rules = {
                ...input.rules,
                maxLength: {
                  value: input.length,
                  message: `Solo puede contener ${input.length}`,
                },
              };
              return { component: <InputText input={input} />, input };
            case 'direccion':
            case 'alfanumerico':
              input.subType = 'text';
              input.rules = {
                ...input.rules,
                pattern: setPatern(
                  validDirecciones,
                  'El texto ingresado no debe contener caracteres especiales',
                ),
              };
              return { component: <InputText input={input} />, input };
            case 'fecha':
              input.rules = {
                ...input.rules,
              };

              return { component: <InputDate input={input} />, input };
            case 'desplegable':
              input.rules = {
                ...input.rules,
              };
              // return {
              //   component: <SelectMultiple {...{ ...input, inputs: inputs }} />,
              //   input,
              // };


              if (input.multiple === true || input.multiple === 'true') {
                return {
                  component: <SelectMultiple {...{ ...input, inputs: inputs }} />,
                  input,
                };
              }
              return {
                component: (
                  <Select
                    {...{
                      ...input,
                      inputs: inputsDinamicos,
                      setInputs: setInputsDinamicos,
                    }}
                  />
                ),
                input,
              };
            case 'numeros':
              input.rules = {
                ...input.rules,
              };

              input.subType = 'number';
              input.rules = {
                ...input.rules,
                maxLength: {
                  value: input.length,
                  message: `Solo puede contener ${input.length}`,
                },
              };

              return { component: <InputText input={input} />, input };
            case 'archivo':
              input.rules = {
                ...input.rules,
              };

              return {
                component: <InputFile input={input} />,
                input,
              };
            case 'subForm':
              console.log('ingresa suform')
              return {
                component: <SubForm {...input} />,
                input,
              };
            case 'check':
              return { component: <InputCheck input={input} />, input, };
            default:
              return {
                component: <p>Input no registrado</p>,
                input,
              };
          }
        })
        .map(({ component, input }) => {
          console.log("componente:", component)
          console.log("input:", input)

          return (
            <ShowOnWrapper input={input} key={uuid.v4()}>
              <Form.Group
                className={classnames({
                  'my-4 align-self-end': input.type !== "check",
                  'my-1 align-self-end': input.type === "check",
                  'col-md-6': input?.validacion !== 'subForm' && input.type !== "check",
                  'col-12': input?.validacion === 'subForm' || input.type === "check",
                })}
              >
                {component}
              </Form.Group>
            </ShowOnWrapper>
          );
        }),
    );
  }, [inputsDinamicos]);

  return form;
};

/*


*/

export default InputsDinamicos;